/**
 * TR uyumlu arama: büyük/küçük harf + Türkçe karakter katlama (ş↔s, ı↔i, …).
 * Backend `normalizeTurkishForSearch` ile aynı mantık.
 */

export const normalizeForSearch = (s) =>
  String(s || '')
    .normalize('NFC')
    .toLocaleLowerCase('tr-TR')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ş/g, 's')
    .replace(/ı/g, 'i')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c');

/** @deprecated use normalizeForSearch — productPickerCore uyumluluğu */
export const foldSearch = normalizeForSearch;

export const searchTokens = (raw) =>
  normalizeForSearch(raw)
    .split(/\s+/)
    .filter((t) => t.length > 0);

export const includesNormalized = (haystack, needle) => {
  const n = normalizeForSearch(needle);
  if (!n) return true;
  return normalizeForSearch(haystack).includes(n);
};

/** Genel metin araması: TR normalize, token + boşluksuz compact eşleşme */
export const matchesSearchQuery = (haystackParts, queryRaw) => {
  const tokens = searchTokens(queryRaw);
  if (!tokens.length) return true;

  const hay = normalizeForSearch(
    (Array.isArray(haystackParts) ? haystackParts : [haystackParts])
      .filter((x) => x != null && String(x).trim() !== '')
      .join(' '),
  );
  if (!hay) return false;

  const hayCompact = hay.replace(/\s+/g, '');
  const queryCompact = tokens.join('');

  if (tokens.every((t) => hay.includes(t))) return true;
  if (queryCompact.length >= 2 && hayCompact.includes(queryCompact)) return true;

  return false;
};

export const matchesSearchTokens = (haystackParts, tokens) => {
  if (!tokens.length) return true;
  return matchesSearchQuery(haystackParts, tokens.join(' '));
};
